export const environment = {
  production: false,
  api_url: 'https://paxi-parcel-web-service-m2d4u4fhnq-ew.a.run.app/parcel/fetchparceltrackingfull',
};
